import './modules/menu';
import './modules/scroll-to';
import './modules/validation';

import './pages/main';
import './pages/brand';
import './pages/card-and-order';
import './pages/card-brand';
import './pages/catalog';
import './pages/complect-card';
import './pages/contacts';
import './pages/item-card';
import './pages/news-detail';
import './pages/complex-map';
import './pages/map';
import './pages/departaments';